var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29163 18.3337C3.94996 18.3337 3.66663 18.0503 3.66663 17.7087V2.29199C3.66663 1.95033 3.94996 1.66699 4.29163 1.66699C4.63329 1.66699 4.91663 1.95033 4.91663 2.29199V17.7087C4.91663 18.0503 4.63329 18.3337 4.29163 18.3337Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M15.0166 10.2755L14 9.25879C13.7583 9.05046 13.6166 8.74212 13.6083 8.40046C13.5916 8.02546 13.7416 7.65046 14.0166 7.37546L15.0166 6.37546C15.8833 5.50879 16.2083 4.67546 15.9333 4.01712C15.6666 3.36712 14.8416 3.00879 13.625 3.00879H4.29164C4.11664 3.01712 3.97498 3.15879 3.97498 3.33379V13.3338C3.97498 13.5088 4.11664 13.6505 4.29164 13.6505H13.625C14.825 13.6505 15.6333 13.2838 15.9083 12.6255C16.1833 11.9588 15.8666 11.1338 15.0166 10.2755Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.462f2d65e006ee42c4e980afcbdd59b0.svg";
export { ForwardRef as ReactComponent };